module.exports = __webpack_public_path__ + "img/zuijia_26.554739da.png";